import { withStyles } from "@material-ui/core";
import styles from "./styles";
import reportConstants from "../../constants";
import PopupFieldRenderer from "./common/PopupFieldRenderer";
import constants from "./constants";
const DelayStopPopup = ({ task, classes }) => {
  return (
    <div className={classes.popupContainer}>
      <PopupFieldRenderer
        label={
          task.data.stopType === reportConstants.DISPATCH_STOP_TYPES.FUELBREAK
            ? constants.POPUP_LABELS.FUEL_BREAK
            : constants.POPUP_LABELS.LUNCH_BREAK
        }
        value={`${task.arrivalTime} - ${task.departureTime}`}
        valueClassName={classes.headerRowValue}
      />
    </div>
  );
};

export default withStyles(styles)(DelayStopPopup);
